import { render, staticRenderFns } from "./CompetitionAvgPriceInTime.vue?vue&type=template&id=c967215a&scoped=true&"
import script from "./CompetitionAvgPriceInTime.vue?vue&type=script&lang=js&"
export * from "./CompetitionAvgPriceInTime.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c967215a",
  null
  
)

export default component.exports